import { render, staticRenderFns } from "./MiniBar.vue?vue&type=template&id=64b6e29e&scoped=true&"
import script from "./MiniBar.vue?vue&type=script&lang=js&"
export * from "./MiniBar.vue?vue&type=script&lang=js&"
import style0 from "./MiniBar.vue?vue&type=style&index=0&id=64b6e29e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b6e29e",
  null
  
)

export default component.exports